// extracted by mini-css-extract-plugin
export default {"layout":"BookingRequestPage_layout__nNRn6"};